export function calculateTotalPrice(food, quantity, selectedAddons) {
  const basePrice = (food?.itemBasePrice || 0) * quantity;
  // debugger
  let addonsPrice = 0;

  (food?.addOns || []).forEach((addon) => {
    const sel = selectedAddons[addon.id];

    if (!sel) return;

    let addonQty = 0;

    // Case 1: Countable addon
    if (addon.isCountable) {
      addonQty = addon.isCountableLinked ? quantity : sel.quantity || 0;
      addonsPrice += (addon.basePrice || 0) * addonQty;
    }

    // Case 2: Non-countable and not linked — calculate from options
    else if (!addon.isCountable && !addon.isCountableLinked) {
      addonQty = Object.entries(sel.options || {}).reduce(
        (total, [optionId, optionSel]) => {
          if (!optionSel?.enabled) return total;

          const optionDef = (addon.options || []).find(
            (o) => o.optionId === optionId
          );
          if (!optionDef) return total;

          const optionQty = optionDef.isCountableLinked
            ? quantity
            : optionDef.isCountable
            ? optionSel.quantity || 0
            : 1;

          return total + optionQty;
        },
        0
      );

      // Add base price if addon is toggled but no option is selected
      if (addonQty === 0 && sel.enabled) {
        addonQty = 1;
      }

      addonsPrice += (addon.basePrice || 0) * addonQty;
    }

    // Case 3: Non-countable but linked — toggle-based
    else if (sel.enabled) {
      addonQty = addon.isCountableLinked ? quantity : 1;
      addonsPrice += (addon.basePrice || 0) * addonQty;
    }

    // Calculate options price (only enabled ones)
    if (sel.options) {
      Object.entries(sel.options).forEach(([optionId, optionSel]) => {
        if (optionSel?.enabled) {
          // Find the option definition
          const optionDef = (addon.options || []).find(
            (o) => o.optionId === optionId
          );
          if (optionDef) {
            //If addon is countable and option is not linked, use addon quantity and
            // Use food item quantity if option is linked, otherwise use option quantity
            const optionQty =
              addon.isCountable && !optionDef.isCountableLinked
                ? sel.quantity || 0
                : optionDef.isCountableLinked
                ? quantity
                : optionDef.isCountable
                ? optionSel.quantity || 0
                : 1;

            addonsPrice += (optionDef.basePrice || 0) * optionQty;

            // Calculate sub-options price
            if (
              optionSel.subOptions &&
              optionDef.subOptions &&
              optionSel.quantity !== 0
            ) {
              // debugger
              Object.entries(optionSel.subOptions).forEach(
                ([subOptionId, subOptionSel]) => {
                  if (subOptionSel?.enabled) {
                    const subOptionDef = (optionDef.subOptions || []).find(
                      (so) => so.subOptionId === subOptionId
                    );
                    if (subOptionDef) {
                      // Use parent option quantity for sub-option
                      const subOptionQty = optionQty;
                      addonsPrice += (subOptionDef.price || 0) * subOptionQty;
                    }
                  }
                }
              );
            }
          }
        }
      });
    }
  });
  return basePrice + addonsPrice;
}

export function formatInitialSelectionsFromBackend(data) {
  const initialSelections = {
    quantity: data?.foodItemQuantity || 1,
    addons: {},
  };

  data?.addOns?.forEach((addon) => {
    const formattedAddon = {
      quantity: addon.addOnQuantity || 0,
      enabled: addon.addOnQuantity > 0 || addon.options?.length > 0,
      options: {},
    };

    addon.options?.forEach((option) => {
      // debugger
      const formattedOption = {
        enabled: option.optionQuantity > 0,
        // quantity: option.optionQuantity || 0,
        quantity: option.isCountableLinked
          ? initialSelections.quantity
          : option.optionQuantity || 0,
        subOptions: {},
      };

      option.subOptions?.forEach((sub) => {
        formattedOption.subOptions[sub.subOptionId] = {
          enabled: sub.subOptionQuantity > 0,
          //Set sub-option quantity to parent option quantity
          quantity: formattedOption.quantity,
        };
      });

      formattedAddon.options[option.optionId] = formattedOption;
    });

    initialSelections.addons[addon.addOnId] = formattedAddon;
  });

  return initialSelections;
}

export function syncQuantitiesBySequence(componentData, apiData) {
  const componentAddons = Object.values(componentData.addons || {});
  const apiAddonKeys = Object.keys(apiData);

  apiAddonKeys.forEach((addonKey, addonIndex) => {
    const apiAddon = apiData[addonKey];
    const componentAddon = componentAddons[addonIndex];

    // Sync addon quantity if present
    if (componentAddon?.quantity != null) {
      apiAddon.quantity = componentAddon.quantity;
    }

    const componentOptions = Object.values(componentAddon?.options || {});
    const apiOptionKeys = Object.keys(apiAddon.options || {});

    apiOptionKeys.forEach((optionKey, optionIndex) => {
      const apiOption = apiAddon.options[optionKey];
      const componentOption = componentOptions[optionIndex];

      // Sync option quantity if present
      if (componentOption?.quantity != null) {
        apiOption.quantity = componentOption.quantity;
      }

      const componentSubOptions = Object.values(
        componentOption?.subOptions || {}
      );
      const apiSubOptionKeys = Object.keys(apiOption.subOptions || {});

      apiSubOptionKeys.forEach((subOptionKey, subIndex) => {
        const apiSubOption = apiOption.subOptions[subOptionKey];
        const componentSubOption = componentSubOptions[subIndex];

        // Sync sub-option quantity to parent option quantity
        if (componentSubOption?.enabled) {
          apiSubOption.quantity = componentOption?.quantity || 0;
        }
      });
    });
  });

  return apiData;
}

export const getFoodStatus = (activeStatus, outOfHourStatus) => {
  if (activeStatus === 0 && outOfHourStatus === 0) {
    return "Unavailable";
  } else if (activeStatus === 0 && outOfHourStatus === 1) {
    return "Unavailable";
  } else if (activeStatus === 1 && outOfHourStatus === 1) {
    return "Out of hour";
  } else if (activeStatus === 1 && outOfHourStatus === 0) {
    return "Available";
  } else {
    return "Unknown status";
  }
};
